import { useMap } from "react-leaflet";
import { FiMaximize, FiMinimize } from "react-icons/fi";
import { useState, useEffect } from "react";

export const FullscreenControl = () => {
  const map = useMap();
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const isCurrentlyFullscreen = !!document.fullscreenElement;
      setIsFullscreen(isCurrentlyFullscreen);

      setTimeout(() => {
        map.invalidateSize();
      }, 200);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
      document.removeEventListener("msfullscreenchange", handleFullscreenChange);
    };
  }, [map]);

  const toggleFullscreen = () => {
    const mapContainer = map.getContainer();

    if (!document.fullscreenElement) {
      if (mapContainer.requestFullscreen) {
        mapContainer.requestFullscreen();
      } else if (mapContainer.webkitRequestFullscreen) {
        mapContainer.webkitRequestFullscreen();
      } else if (mapContainer.msRequestFullscreen) {
        mapContainer.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  return (
    <button
      type="button"
      onClick={toggleFullscreen}
      title="Fullscreen Mode"
      className="absolute z-[1000] bottom-5 right-5 bg-white p-2 rounded-lg border border-gray-200 hover:bg-gray-50 flex items-center justify-center transition-all shadow-md"
      style={{ width: "40px", height: "40px" }}
    >
      {isFullscreen ? (
        <FiMinimize size={20} className="text-gray-700" />
      ) : (
        <FiMaximize size={20} className="text-gray-700" />
      )}
    </button>
  );
};